<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-16 16:45:11
 * @Description: 近一个月用户数量趋势
 // eslint-disable-next-line max-len
 * @FilePath: \fuzhou\src\module\overview\stationChargeModal\components\recentDayChargingPw.vue
-->
<template>
  <div class="recent-day-charging-pw">
    <pub-info-title :title="'近一个月用户数量趋势'" :isModal="true" />
    <div ref="ansLine" class="power-line-chart"></div>
  </div>
</template>
<script>
import moment from "moment";
import pubInfoTitle from '@/components/infoTitle/index.vue';
import * as Echarts from 'echarts';

export default {
  name: 'recentDayChargingPw',
  components: {
    pubInfoTitle,
  },
  props: {
    userNumber: {
      type: Array,
      default: () => ([]),
    },
    // xAxisData: {
    //   type: Array,
    //   default: () => ([]),
    // },
  },
  data() {
    return {
      chart: null,
      xAxisData: [],
    };
  },
  watch: {
    userNumber: {
      handler() {
        this.lineChartsInit();
      },
      deep: true,
    },
  },
  mounted() {
    this.xAxisData = this.getMonthDate();
    this.lineChartsInit();
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
  methods: {
    // 获取30天的日期 01-01
    getMonthDate() {
      let arr=[]
      for (let i = 30; i > 0; i--) {
        let currentDay=moment().subtract(i, 'days').format('MM-DD')
        arr.push(currentDay)
      }
      return arr;
    },
    lineChartsInit() {
      this.chart = Echarts.init(this.$refs.ansLine);
      const option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: this.fitChartSize(30),
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['5%', '5%'],
          data: [...this.xAxisData],
          axisTick: {
            show: false, // x 轴刻度是否显示
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#9A9A9A',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(14),
          },
        },
        yAxis: [
          {
            name: '人',
            nameLocation: 'end',
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, 2, 0, 0],
            },
            type: 'value',
            axisLabel: {
              color: '#C5C5C5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '用户数量',
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#32BAFF',
              shadowColor: '#32BAFF',
              shadowBlur: 8,

            },
            lineStyle: {
              color: '#4AC9FA',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(48, 183, 255, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(3, 132, 255, 0)',
                },
              ]),
            },
            data: [...this.userNumber],
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.recent-day-charging-pw {
  ::v-deep .pub-info-title {
    margin-bottom: 16px;
  }
  .power-line-chart {
    width: 100%;
    height: 175px;
  }
}
</style>
